"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initConfig = initConfig;
exports.setInstitution = setInstitution;
exports.setLoginPreload = setLoginPreload;
exports.setAccounts = setAccounts;
exports.setSelectedAccounts = setSelectedAccounts;
exports.setIncomeAccountData = setIncomeAccountData;
exports.reset = reset;
exports.Actions = void 0;
var Actions;
exports.Actions = Actions;

(function (Actions) {
  Actions["INIT_CONFIG"] = "INIT_CONFIG";
  Actions["SET_INSTITUTION"] = "SET_INSTITUTION";
  Actions["SET_LOGIN_PRELOAD"] = "SET_LOGIN_PRELOAD";
  Actions["SET_ACCOUNTS"] = "SET_ACCOUNTS";
  Actions["SET_SELECTED_ACCOUNTS"] = "SET_SELECTED_ACCOUNTS";
  Actions["SET_INCOME_ACCOUNT_DATA"] = "SET_INCOME_ACCOUNT_DATA";
  Actions["RESET"] = "RESET";
})(Actions || (exports.Actions = Actions = {}));

function initConfig(userToken, guid) {
  return {
    type: Actions.INIT_CONFIG,
    data: {
      guid: guid,
      userToken: userToken
    }
  };
}

function setInstitution(institution) {
  return {
    type: Actions.SET_INSTITUTION,
    data: institution
  };
}

function setLoginPreload(institution) {
  return {
    type: Actions.SET_LOGIN_PRELOAD,
    data: institution
  };
}

function setAccounts(accounts) {
  return {
    type: Actions.SET_ACCOUNTS,
    data: accounts
  };
}

function setSelectedAccounts(accounts) {
  return {
    type: Actions.SET_SELECTED_ACCOUNTS,
    data: accounts
  };
}

function setIncomeAccountData(data) {
  return {
    type: Actions.SET_INCOME_ACCOUNT_DATA,
    data: data
  };
}

function reset() {
  return {
    type: Actions.RESET
  };
}